import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import SalesTeamDashboard from '../SalesTeamDashboard';

/**
 * The Thread style of the sales head / sales manager home: the shared role-lens layout fed by the sales lens.
 * The server scopes everything to the caller's teams and reps, so this stays a thin wrapper.
 */
export default function SalesLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.sales">
            <RoleLensBoard institutionId={institutionId} lens="sales" fallback={<SalesTeamDashboard />} />
        </Box>
    );
}
